import React from 'react';
import { QuoteIcon } from 'lucide-react';
import { FadeIn } from './FadeIn';
const testimonials = [{
  quote: "Apostle Phillips' ministry has profoundly shifted the trajectory of our church. His prophetic insight and leadership wisdom are unmatched in this generation.",
  author: 'Pastor David M.',
  role: 'Lead Pastor, Grace Fellowship'
}, {
  quote: "The teachings I've received through this ministry have completely transformed my understanding of spiritual authority. It's not just preaching; it's an impartation.",
  author: 'Sarah J.',
  role: 'Conference Attendee'
}];
export function TestimonialsSection() {
  return <section className="py-24 md:py-32 bg-charcoal relative overflow-hidden" data-id="element-288">
      {/* Decorative large quote mark */}
      <div className="absolute top-10 left-10 md:top-20 md:left-20 opacity-5" data-id="element-289">
        <QuoteIcon className="w-64 h-64 text-white" data-id="element-290" />
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10" data-id="element-291">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-292">
          {testimonials.map((testimonial, index) => <FadeIn key={index} delay={index * 0.2} data-id="element-293">
              <div className="flex flex-col h-full" data-id="element-294">
                <QuoteIcon className="w-12 h-12 text-gold mb-8" data-id="element-295" />
                <p className="text-2xl md:text-3xl font-playfair text-white leading-relaxed mb-8 flex-grow" data-id="element-296">
                  "{testimonial.quote}"
                </p>
                <div data-id="element-297">
                  <div className="text-gold font-bold font-inter text-lg" data-id="element-298">
                    {testimonial.author}
                  </div>
                  <div className="text-gray-400 font-inter text-sm mt-1" data-id="element-299">
                    {testimonial.role}
                  </div>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}